import httpService from './http.service';

export default {
  generate,
};

async function generate(filters) {
  return httpService.post('/reports/dre', filters);
}
